<template>
  <q-list>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_1" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I authorize {{ plan_brand(selected_plan) }} to perform a credit check and review my credit and payment history with
          credit reporting agencies, its affiliates, and my previous electricity providers based on my information that I have provided for enrollment.
          I understand that if I do not qualify under {{ plan_brand(selected_plan) }}’s deposit criteria and payment history, I may be required to pay a deposit and/or an outstanding balance before my enrollment is complete.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_2" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          Yes, I wish to sign up for the {{ selected_plan.product.name }}
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_3" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I have read and understand the
          <a :href="plan_doc_link(selected_plan, 'tos')" target="_blank" class="cp-non-link">Terms of Service</a>,
          <a :href="plan_doc_link(selected_plan, 'efl')" target="_blank" class="cp-non-link">Electricity Facts Label</a>,
          and
          <a :href="plan_doc_link(selected_plan, 'yraac')" target="_blank" class="cp-non-link">Your Rights as a
            Customer</a>
          documents. I understand that a move-in or switch request can only be made by the electric service applicant or
          the applicant's authorized agent and I agree to allow {{ plan_brand(selected_plan) }} to perform the
          necessary tasks to complete a switch or move-in for my service with {{ plan_brand(selected_plan) }}. I
          verify that I am at least 18 years of age and legally authorized to buy electricity for the address listed
          above. I agree to pay the price as specified above. The price includes (i) the Energy Charge, (ii) applicable
          Transmission and Distribution Utility ("TDU") tariff, if not included in the Energy Charge, (iii) a Monthly
          Base charge per ESI-ID, and (iv) all recurring charges. This price does not include applicable federal, state
          and local taxes or any fees (including gross receipt tax reimbursement), other amounts charged by a
          governmental entity, and all other non-recurring fees. By selecting a specific switch date, you are agreeing
          to an off-cycle switch fee that is passed-through from your TDSP without mark-up. See the Electricity Facts
          Label for specific pricing details. If a switch transaction was selected, I may rescind this agreement without penalty before midnight of the third
          federal business day after submitting this enrollment. After this period or for new (move-in) service, an early termination fee of $175 per ESIID for each full and
          partial year left in the term will apply if I cancel this agreement without providing proof of my move
          (including a forwarding address). I can print and save copies of these documents which are provided above. I
          understand that after submitting this enrollment request, I will also receive a copy of these documents,
          including the Terms of Service, from {{ plan_brand(selected_plan) }} via email, and upon request,
          via US mail, and that these documents, including the Terms of Service, explain all the terms of the agreement
          and how to exercise the right of rescission, if applicable.
        </q-item-label>
      </q-item-section>
    </q-item>

  </q-list>
</template>

<script>
import SelectedPlan from "src/composables/SelectedPlan";
import { watch, ref } from "vue";
import Utilities from "src/composables/Utilities";

export default {
  name: "JustEnergyAuthorizations",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { selected_plan } = SelectedPlan();
    const { plan_brand, plan_doc_link } = Utilities();
    const authorizations = ref([]);
    watch(authorizations, () => {
      const agreed = authorizations.value.length === 3
      emit('update:modelValue', agreed);
    })
    return {
      authorizations,
      selected_plan,

      plan_brand,
      plan_doc_link
    }
  }
}
</script>

<style scoped>

</style>
